import { Product } from "types/product.type";

export default function buildProductFormData(form: Partial<Product>): FormData {
  const formData = new FormData();
  Object.entries(form).forEach(([key, value]) => {
    if (
      key !== "imageFiles" &&
      key !== "category" &&
      key !== "subcategory" &&
      key !== "creator" &&
      value != null
    ) {
      if (typeof value === "object") {
        formData.append(key, JSON.stringify(value));
      } else {
        formData.append(key, String(value));
      }
    }
  });
  formData.append("existingImages", JSON.stringify(form.images || []));
  form.imageFiles?.forEach((file) => formData.append("images", file));
  return formData;
}
